import React from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

import { classList } from '@/helpers';
import { ButtonCancel, ButtonSave } from '@/components/common';

interface IProps {
  primaryBtnText?: string;
  secondaryBtnText?: string;
  info?: React.ReactNode;
  buttonsSize?: 'shrink' | 'grow';
  onSecondaryBtnClick: () => void;
  onPrimaryBtnClick?: () => void;
  hideSecondaryBtn?: boolean;
  primaryDisabled?: boolean;
  secondaryDisabled?: boolean;
}

const ModalFooter = ({
  info,
  buttonsSize = 'shrink',
  primaryBtnText,
  secondaryBtnText,
  onSecondaryBtnClick,
  onPrimaryBtnClick,
  hideSecondaryBtn = false,
  primaryDisabled,
  secondaryDisabled,
}: IProps): React.ReactElement => (
  <Modal.Footer className={classList('mt-2', !!info && 'justify-content-between')}>
    {info}
    <ButtonsContainer className={classList('d-flex', buttonsSize)}>
      {!hideSecondaryBtn && (
        <ButtonCancel
          disabled={secondaryDisabled}
          className={classList(info ? 'ms-2' : 'ms-0', buttonsSize)}
          onClick={onSecondaryBtnClick}
          text={secondaryBtnText}
        />
      )}
      <ButtonSave
        disabled={primaryDisabled}
        type="submit"
        onClick={e => {
          if (onPrimaryBtnClick) {
            e.preventDefault();
            onPrimaryBtnClick();
          }
        }}
        className={classList('ms-2', buttonsSize)}
        label={primaryBtnText}
      />
    </ButtonsContainer>
  </Modal.Footer>
);

export { ModalFooter };

const ButtonsContainer = styled.div`
  &.grow,
  .grow {
    flex-grow: 1;
  }
`;
